import React, {useContext, useEffect, useState} from "react";
import {Dropdown, Layout, Menu, Tooltip,} from "antd";
import styles from "./ChatGroup.module.scss";
import {ChatConstants, width} from "./Chat.const";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import Member from "src/assets/png/newIcon/Chat room/Member.png";
import inviteGroup from "src/assets/png/newIcon/Chat room/InviteFriend.png";
import EditName from "src/assets/png/newIcon/Chat room/EditNameGroup.png";
import File_ from "src/assets/png/newIcon/Chat room/File.png";
import Location_ from "src/assets/png/newIcon/Chat room/location.png";
import Call from "src/assets/png/newIcon/Chat room/Call.png";
import VideoCall from "src/assets/png/newIcon/Chat room/VideoCall.png";
import delete_ from "src/assets/png/newIcon/Chat room/DeleteGroup_1.png";
import ChatContentTab from "../../chatTab/ChatContentTab";
import LocationContent from "../../location/LocationContent";
import File from "../../FileContent";
import AppsContent from "../../AppsContent";
import {AppContext} from "src/pages/context/App.context";
import InviteChat from "../../InviteChat";
import {pathRoutes} from "src/props/util.props";
import {ChatContext} from "src/pages/context/Chat.context";
import {CommunityContext} from "src/pages/context/Community.context";
import UIModalConfrimDeleteGroup from "../../component/UIModalConfrimDeleteGroup";
import moregrayImg from "src/assets/png/more_gray.png";
import {camSearchParam} from "../../../videoCall/VideoConference/utils/janusUtils";
import {isTrue} from "src/service/util.service";

const {Header, Footer, Sider, Content} = Layout;

const MEMBER_ROLE = {
    ADMIN: "admin",
    OWNER: "owner",
    MEMBER: "member",
};

interface ChatGroupProps {
    id: string;
    name: string;
    coverImgURL?: string;
    imageID?: string;
    privacyLevel?: number;
    group: any;
    isGroup: any;
    member: any;
    user: any;
    community?: any;
    clearChat?: () => void;
    type: string;
    isNewChat?: boolean;
    newChat?: any;
}

const ChatGroup: React.FunctionComponent<ChatGroupProps> = (props) => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const appContext: any = useContext(AppContext);
    const chatCtx: any = useContext(ChatContext);
    const [tabName, setTabName]: any = useState(null);
    const [memberRole, setMemberRole]: any = useState(null);
    const [showDeleteGroup, setShowDeleteGroup]: any = useState(false);
    const [isVoice, setIsVoice] = useState(false);
    const [isVideoCall, setIsVideoCall] = useState(false);
    const [isGroupVoice, setIsGroupVoice] = useState(false);
    const [isGroupVideoCall, setIsGroupVideoCall] = useState(false);

    const clickTab = (tabName: string) => {
        setTabName(tabName);
    };

    const checkMemberRole = (members: any, user: any) => {
        const thisUser = members.find((member: any) => {
            return member.userID === user.id;
        });
        setMemberRole(thisUser?.memberRole);
    };

    const communityCtx: any = useContext(CommunityContext);
    useEffect(() => {
        if (tabName === ChatConstants.EditName) {
            navigate(pathRoutes.createGroup + "?id=" + props.id);
        } else if (tabName === ChatConstants.File) {
            console.log(" file : ", props.group);
            // navigate(pathRoutes.File + "?id=" + props.id);
            if (props.group?.mainType === "community") {
                try {
                    communityCtx.setContent("file");
                } catch (e) {
                    console.log(e);
                }
                // navigate({
                //   pathname: pathRoutes.groupCommunity,
                //   search: `/id/${props.group.id}/tab/file`,
                // });
                navigate(`${pathRoutes.groupCommunity}/${props?.group?.id}/file`);
                // navigate(pathRoutes.groupCommunity + `?id=${props.group.id}&tab=file`);
            } else {
                // navigate(pathRoutes.Chat + "?id=" + props.groupID);
                navigate(pathRoutes.File + "/id/" + props.id);
            }
        } else if (tabName === ChatConstants.VideoCall) {
            if (props.isGroup) {
                // navigate(pathRoutes.videoCall + "?id=" + props.id + "&video=true");
                navigate(
                    pathRoutes.conference +
                    "?id=" +
                    props.id +
                    "&" +
                    camSearchParam +
                    "=true"
                );
            } else {
                const calleeUser = getCalleeId(props.member, props.user);
                if (!calleeUser) return;
                const path = `${pathRoutes.personalCall}?id=${props.id}&isVideoCall=true&calleeId=${calleeUser.userID}`;
                navigate(path);
                // navigate(
                //   pathRoutes.personalCall + "?id=" + props.id + "&isVideoCall=true"
                // );
            }
        } else if (tabName === ChatConstants.Call) {
            if (props.isGroup) {
                // navigate(pathRoutes.call + "?id=" + props.id + "&video=false");
                navigate(
                    pathRoutes.conference +
                    "?id=" +
                    props.id +
                    "&" +
                    camSearchParam +
                    "=false"
                );
            } else {
                const calleeUser = getCalleeId(props.member, props.user);
                if (!calleeUser) return;
                const path = `${pathRoutes.personalCall}?id=${props.id}&isVideoCall=false&calleeId=${calleeUser.userID}`;
                navigate(path);
            }
        }
    }, [tabName]);

    const getCalleeId = (members: any, user: any) => {
        return members.find((member: any) => {
            return member.userID !== user;
        });
    };

    const clickDelete = () => {
        setShowDeleteGroup(true);
    };

    useEffect(() => {
        if (props.member !== undefined && props.user !== undefined) {
            checkMemberRole(props.member, props.user);
        }

        clickTab(ChatConstants.Chat);
        // console.log("members: ",props?.member);
    }, [props]);

    useEffect(() => {
        if (!appContext.objectAccesses) return;
        setIsVoice(appContext.objectAccesses?.["PERSONAL_VOICE_CALL"]);
        setIsVideoCall(appContext.objectAccesses?.["PERSONAL_VIDEO_CALL"]);
        setIsGroupVoice(appContext.objectAccesses?.["GROUP_VOICE_CALL"]);
        setIsGroupVideoCall(appContext.objectAccesses?.["GROUP_VIDEO_CALL"])

        console.log("::>>>", appContext.objectAccesses?.["PERSONAL_VOICE_CALL"]);
        console.log("::>>", appContext.objectAccesses?.["PERSONAL_VIDEO_CALL"]);
        console.log("::>>", appContext.objectAccesses?.["GROUP_VIDEO_CALL"]);
        console.log("::>>", appContext.objectAccesses?.["GROUP_VOICE_CALL"]);


        console.log(props?.member);
    }, [appContext.objectAccesses]);

    const getWidth = () => {
        let width = "100%";
        if (window.location.href.indexOf("/group-community") !== -1) {
            // width = "calc(100% - 250px)";
        }
        return width;
    };

    // useEffect(() => {
    //     console.log("1.memberRole", memberRole);
    //     console.log("1.props.isGroup", props.isGroup);
    //     console.log("1.props.member", props.member);
    //     console.log("1.props.user", props.user);
    // }, [memberRole, props.isGroup, props.member, props.user])

    return (
        <Layout
            style={{backgroundColor: props?.community ? "rgba(255,255,255,0)" : ""}}
        >
            <Content>
                <div
                    style={{
                        width: getWidth(),
                        // width: `calc(100% - ${width}px - ${width}px)`,
                        height: 72,
                        position: "absolute",
                        zIndex: 1,
                        display: tabName == ChatConstants.InviteChat ? "none" : "flex",
                        paddingLeft: 10,
                        paddingRight: 10,
                    }}
                >
                    <div className={styles.boxHeader}>
                        <div
                            style={{
                                // width: `calc(100% - ${width*2+48}px)`,
                                display: "inline-flex",
                                overflow: "hidden",
                                textOverflow: "elipsis",
                                // width: chatCtx.showUserList ? "60%" : "40%",
                                justifyContent: "space-between",
                            }}
                        >
                            <div
                                style={{
                                    paddingLeft: 10,
                                    overflow: "hidden",
                                }}
                            >
                                <Tooltip placement="bottom" title={props.name} color="#0f4c82">
                                    <div
                                        style={{
                                            fontSize: "1.3rem",
                                            fontWeight: 700,
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            paddingRight: "10px",
                                            cursor: "default",
                                        }}
                                    >
                                        {props.name}
                                    </div>
                                </Tooltip>
                            </div>
                            {props.isGroup && (
                                <div style={{display: "inline-flex", alignItems: "center"}}>
                                    <div
                                        style={{
                                            backgroundImage: `url(${Member})`,
                                            width: 27,
                                            height: 27,
                                            backgroundRepeat: "no-repeat",
                                            backgroundSize: "cover",
                                            cursor: "pointer",
                                        }}
                                        onClick={() => {
                                            if (chatCtx.showUserList) {
                                                chatCtx.setShowUserList(false);
                                            } else {
                                                chatCtx.setShowUserList(true);
                                            }

                                            chatCtx.setShowUserDetail(false);
                                        }}
                                    ></div>
                                    <div
                                        style={{
                                            marginLeft: 5,
                                            paddingRight: 10,
                                            fontSize: "1.2rem",
                                            marginTop: 3,
                                        }}
                                    >
                                        {props.member.length}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div
                            style={{
                                display: "inline-flex",
                                width: chatCtx.showUserList ? "200px" : "300px",
                                justifyContent: "space-between",
                                height: "100%",
                            }}
                            className={styles.menuChatInside}
                        >
                            <div
                                style={{
                                    display:
                                        props.isGroup &&
                                        memberRole === MEMBER_ROLE.OWNER
                                            ? "inline-flex"
                                            : "none",
                                    alignItems: "center",
                                    width: "100%",
                                    justifyContent: "center",
                                }}
                            >
                                <Tooltip
                                    placement="bottom"
                                    title={t("Edit Name")}
                                    color="#0f4c82"
                                >
                                    <div
                                        style={{
                                            // margin: 'auto',
                                            backgroundImage: `url(${EditName})`,
                                            width: 27,
                                            height: 27,
                                            // marginRight: 29,
                                            cursor: "pointer",
                                            backgroundSize: "contain",
                                        }}
                                        onClick={() =>
                                            tabName === ChatConstants.EditName
                                                ? clickTab(ChatConstants.Chat)
                                                : clickTab(ChatConstants.EditName)
                                        }
                                    ></div>
                                </Tooltip>
                            </div>
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    borderLeft: "1px solid #DADADA",
                                    width: "100%",
                                    justifyContent: "center",
                                }}
                            >
                                <Tooltip placement="bottom" title={t("File")} color="#0f4c82">
                                    <div
                                        style={{
                                            backgroundImage: `url(${File_})`,
                                            width: 27,
                                            height: 27,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            // marginRight: 29,
                                            WebkitBackgroundSize: "contain",
                                            cursor: "pointer",
                                        }}
                                        onClick={() =>
                                            tabName === ChatConstants.File
                                                ? clickTab(ChatConstants.Chat)
                                                : clickTab(ChatConstants.File)
                                        }
                                    ></div>
                                </Tooltip>
                            </div>
                            <div
                                style={{
                                    display: "inline-flex",
                                    alignItems: "center",
                                    borderLeft: "1px solid #DADADA",
                                    width: "100%",
                                    justifyContent: "center",
                                }}
                            >
                                <Tooltip
                                    placement="bottom"
                                    title={t("Location")}
                                    color="#0f4c82"
                                >
                                    <div
                                        style={{
                                            backgroundImage: `url(${Location_})`,
                                            width: 27,
                                            height: 27,
                                            backgroundRepeat: "no-repeat",
                                            backgroundPosition: "center",
                                            // marginRight: 29,
                                            cursor: "pointer",

                                            marginTop: "-3px",
                                            backgroundSize: "contain",
                                        }}
                                        onClick={() =>
                                            tabName === ChatConstants.Location
                                                ? clickTab(ChatConstants.Chat)
                                                : clickTab(ChatConstants.Location)
                                        }
                                    ></div>
                                </Tooltip>
                            </div>
                            {(memberRole === MEMBER_ROLE.ADMIN ||
                                    memberRole === MEMBER_ROLE.OWNER) &&
                                !chatCtx.showUserList &&
                                props.isGroup && (
                                    <div
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            borderLeft: "1px solid #DADADA",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Tooltip
                                            placement="bottom"
                                            title={t("invite friends")}
                                            color="#0f4c82"
                                        >
                                            <div
                                                style={{
                                                    backgroundImage: `url(${inviteGroup})`,
                                                    width: "27px",
                                                    height: "27px",
                                                    // marginRight: 29,
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: "center",
                                                    cursor: "pointer",

                                                    marginTop: "-4px",
                                                    backgroundSize: "contain",
                                                }}
                                                onClick={() =>
                                                    tabName === ChatConstants.InviteChat
                                                        ? clickTab(ChatConstants.Chat)
                                                        : clickTab(ChatConstants.InviteChat)
                                                }
                                            ></div>
                                        </Tooltip>
                                    </div>
                                )}

                            {/* call */}
                            {!chatCtx.showUserList && ((props.isGroup && isTrue(isGroupVoice))
                                    || (!props.isGroup && isTrue(isVoice)))
                                && (
                                    <div
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            borderLeft: "1px solid #DADADA",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Tooltip
                                            placement="bottom"
                                            title={t("Call")}
                                            color="#0f4c82"
                                        >
                                            <div
                                                style={{
                                                    backgroundImage: `url(${Call})`,
                                                    width: 27,
                                                    height: 27,
                                                    backgroundRepeat: "no-repeat",
                                                    backgroundPosition: "center",
                                                    // marginRight: 29,
                                                    cursor: "pointer",

                                                    marginTop: "0px",
                                                    backgroundSize: "contain",
                                                }}
                                                onClick={() =>
                                                    tabName === ChatConstants.Call
                                                        ? clickTab(ChatConstants.Chat)
                                                        : clickTab(ChatConstants.Call)
                                                }
                                            ></div>
                                        </Tooltip>
                                    </div>
                                )}

                            {/* videocall */}
                            {!chatCtx.showUserList && ((props.isGroup && isTrue(isGroupVideoCall))
                                    || (!props.isGroup && isTrue(isVideoCall)))
                                && (
                                    <div
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            borderLeft: "1px solid #DADADA",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Tooltip
                                            placement="bottom"
                                            title={t("VideoCall")}
                                            color="#0f4c82"
                                        >
                                            <div
                                                style={{
                                                    backgroundImage: `url(${VideoCall})`,
                                                    width: 27,
                                                    height: 27,
                                                    // marginRight: 29,
                                                    cursor: "pointer",

                                                    marginTop: "0px",
                                                    backgroundSize: "cover",
                                                }}
                                                onClick={() =>
                                                    tabName === ChatConstants.VideoCall
                                                        ? clickTab(ChatConstants.Chat)
                                                        : clickTab(ChatConstants.VideoCall)
                                                }
                                            ></div>
                                        </Tooltip>
                                    </div>
                                )}

                            {
                                memberRole === MEMBER_ROLE.OWNER &&
                                !chatCtx.showUserList &&
                                props.isGroup && (
                                    <div
                                        style={{
                                            display: "inline-flex",
                                            alignItems: "center",
                                            borderLeft: "1px solid #DADADA",
                                            width: "100%",
                                            justifyContent: "center",
                                        }}
                                    >
                                        <Tooltip
                                            placement="bottom"
                                            title={t("Delete Group")}
                                            color="#0f4c82"
                                        >
                                            <div
                                                style={{
                                                    backgroundImage: `url(${delete_})`,
                                                    width: 27,
                                                    height: 27,
                                                    // marginRight: 29,
                                                    cursor: "pointer",
                                                    backgroundSize: "cover",
                                                    marginTop: "-3px",
                                                }}
                                                onClick={() => clickDelete()}
                                            ></div>
                                        </Tooltip>
                                    </div>
                                )}
                        </div>

                        <Dropdown
                            className={styles.dropdownMenu}
                            overlay={
                                <Menu>
                                    <Menu.Item>
                                        <div
                                            style={{
                                                display:
                                                    props.isGroup &&
                                                    memberRole === MEMBER_ROLE.OWNER
                                                        ? "inline-flex"
                                                        : "none",
                                                alignItems: "center",
                                                width: "100%",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Tooltip
                                                placement="bottom"
                                                title={t("Edit Name")}
                                                color="#0f4c82"
                                            >
                                                <div
                                                    style={{
                                                        // margin: 'auto',
                                                        backgroundImage: `url(${EditName})`,
                                                        width: 27,
                                                        height: 27,
                                                        // marginRight: 29,
                                                        cursor: "pointer",
                                                        backgroundSize: "contain",
                                                    }}
                                                    onClick={() =>
                                                        tabName === ChatConstants.EditName
                                                            ? clickTab(ChatConstants.Chat)
                                                            : clickTab(ChatConstants.EditName)
                                                    }
                                                ></div>
                                            </Tooltip>
                                        </div>
                                    </Menu.Item>
                                    <Menu.Item>
                                        <div
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                // borderLeft: "1px solid #DADADA",
                                                width: "100%",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Tooltip
                                                placement="bottom"
                                                title={t("File")}
                                                color="#0f4c82"
                                            >
                                                <div
                                                    style={{
                                                        backgroundImage: `url(${File_})`,
                                                        width: 27,
                                                        height: 27,
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundPosition: "center",
                                                        // marginRight: 29,
                                                        backgroundSize: "contain",
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                        tabName === ChatConstants.File
                                                            ? clickTab(ChatConstants.Chat)
                                                            : clickTab(ChatConstants.File)
                                                    }
                                                ></div>
                                            </Tooltip>
                                        </div>
                                    </Menu.Item>
                                    <Menu.Item>
                                        <div
                                            style={{
                                                display: "inline-flex",
                                                alignItems: "center",
                                                // borderLeft: "1px solid #DADADA",
                                                width: "100%",
                                                justifyContent: "center",
                                            }}
                                        >
                                            <Tooltip
                                                placement="bottom"
                                                title={t("Location")}
                                                color="#0f4c82"
                                            >
                                                <div
                                                    style={{
                                                        backgroundImage: `url(${Location_})`,
                                                        width: 27,
                                                        height: 27,
                                                        backgroundRepeat: "no-repeat",
                                                        backgroundPosition: "center",
                                                        // marginRight: 29,
                                                        cursor: "pointer",

                                                        marginTop: "-3px",
                                                        backgroundSize: "contain",
                                                        marginLeft: "-7px",
                                                    }}
                                                    onClick={() =>
                                                        tabName === ChatConstants.Location
                                                            ? clickTab(ChatConstants.Chat)
                                                            : clickTab(ChatConstants.Location)
                                                    }
                                                ></div>
                                            </Tooltip>
                                        </div>
                                    </Menu.Item>
                                    {(memberRole === MEMBER_ROLE.ADMIN ||
                                            memberRole === MEMBER_ROLE.OWNER) &&
                                        !chatCtx.showUserList &&
                                        props.isGroup && (
                                            <Menu.Item>
                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        // borderLeft: "1px solid #DADADA",
                                                        width: "100%",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Tooltip
                                                        placement="bottom"
                                                        title={t("invite friends")}
                                                        color="#0f4c82"
                                                    >
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${inviteGroup})`,
                                                                width: "27px",
                                                                height: "27px",
                                                                // marginRight: 29,
                                                                backgroundRepeat: "no-repeat",
                                                                backgroundPosition: "center",
                                                                cursor: "pointer",

                                                                marginTop: "-4px",
                                                                backgroundSize: "contain",
                                                            }}
                                                            onClick={() =>
                                                                tabName === ChatConstants.InviteChat
                                                                    ? clickTab(ChatConstants.Chat)
                                                                    : clickTab(ChatConstants.InviteChat)
                                                            }
                                                        ></div>
                                                    </Tooltip>
                                                </div>
                                            </Menu.Item>
                                        )}
                                    {/* call */}
                                    {!chatCtx.showUserList
                                        && ((props.isGroup && isTrue(isGroupVoice))
                                            || (!props.isGroup && isTrue(isVoice)))
                                        && (
                                            <Menu.Item>
                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        // borderLeft: "1px solid #DADADA",
                                                        width: "100%",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Tooltip
                                                        placement="bottom"
                                                        title={t("Call")}
                                                        color="#0f4c82"
                                                    >
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${Call})`,
                                                                width: 27,
                                                                height: 27,
                                                                backgroundRepeat: "no-repeat",
                                                                backgroundPosition: "center",
                                                                // marginRight: 29,
                                                                cursor: "pointer",

                                                                marginTop: "0px",
                                                                backgroundSize: "contain",
                                                                marginLeft: "-7px",
                                                            }}
                                                            onClick={() =>
                                                                tabName === ChatConstants.Call
                                                                    ? clickTab(ChatConstants.Chat)
                                                                    : clickTab(ChatConstants.Call)
                                                            }
                                                        ></div>
                                                    </Tooltip>
                                                </div>
                                            </Menu.Item>
                                        )}
                                    {/* videocall  */}
                                    {!chatCtx.showUserList
                                        && ((props.isGroup && isTrue(isGroupVideoCall))
                                            || (!props.isGroup && isTrue(isVideoCall)))
                                        && (
                                            <Menu.Item>
                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        // borderLeft: "1px solid #DADADA",
                                                        width: "100%",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Tooltip
                                                        placement="bottom"
                                                        title={t("VideoCall")}
                                                        color="#0f4c82"
                                                    >
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${VideoCall})`,
                                                                width: 27,
                                                                height: 27,
                                                                // marginRight: 29,
                                                                cursor: "pointer",

                                                                marginTop: "0px",
                                                                backgroundSize: "cover",
                                                            }}
                                                            onClick={() =>
                                                                tabName === ChatConstants.VideoCall
                                                                    ? clickTab(ChatConstants.Chat)
                                                                    : clickTab(ChatConstants.VideoCall)
                                                            }
                                                        ></div>
                                                    </Tooltip>
                                                </div>
                                            </Menu.Item>
                                        )}

                                    {
                                        memberRole === MEMBER_ROLE.OWNER &&
                                        !chatCtx.showUserList &&
                                        props.isGroup && (
                                            <Menu.Item>
                                                <div
                                                    style={{
                                                        display: "inline-flex",
                                                        alignItems: "center",
                                                        // borderLeft: "1px solid #DADADA",
                                                        width: "100%",
                                                        justifyContent: "center",
                                                    }}
                                                >
                                                    <Tooltip
                                                        placement="bottom"
                                                        title={t("Delete Group")}
                                                        color="#0f4c82"
                                                    >
                                                        <div
                                                            style={{
                                                                backgroundImage: `url(${delete_})`,
                                                                width: 27,
                                                                height: 27,
                                                                // marginRight: 29,
                                                                cursor: "pointer",
                                                                backgroundSize: "cover",
                                                                marginTop: "-3px",
                                                                marginLeft: "-3px",
                                                            }}
                                                            onClick={() => clickDelete()}
                                                        ></div>
                                                    </Tooltip>
                                                </div>
                                            </Menu.Item>
                                        )}
                                </Menu>
                            }
                            placement="bottomCenter"
                            arrow
                            trigger={["click"]}
                        >
                            <img
                                src={moregrayImg}
                                width="28"
                                style={{cursor: "pointer", marginRight: "10px"}}
                            />
                        </Dropdown>
                    </div>
                </div>
                {tabName === ChatConstants.Chat && (
                    <>
                        <div
                            style={{
                                height: "96px",
                                // width: "100%",
                                width: `calc(100vw - 56px - ${width}px - ${width - 2}px)`,
                                display: "flex",
                                alignItems: "center",
                            }}
                        ></div>
                        <div
                            style={{
                                height: "calc(100vh - 230px)",
                                width: "100%",
                                position: "relative"
                            }}
                        >
                            <ChatContentTab
                                onBackMainChat={props.clearChat}
                                isNewChat={props.isNewChat}
                                group={props.group}
                                community={props?.community}
                            />
                        </div>
                    </>
                )}
                {tabName === ChatConstants.Location && (
                    <LocationContent groupId={props.id} groupType={props.type}/>
                )}
                {/* {tabName === ChatConstants.File && <FileContent groupId={props.id} />} */}
                {tabName === ChatConstants.Apps && <AppsContent/>}
                {tabName === ChatConstants.InviteChat && (
                    <InviteChat
                        onClose={() => {
                            setTabName(ChatConstants.Chat);
                        }}
                    />
                )}
                {showDeleteGroup && (
                    <UIModalConfrimDeleteGroup
                        id={props.id}
                        onClose={() => {
                            setShowDeleteGroup(false);
                        }}
                    ></UIModalConfrimDeleteGroup>
                )}
            </Content>
        </Layout>
    );
};

export default ChatGroup;
